import React from 'react';
import PropTypes from 'prop-types';

// Components
import StatusBadge from "./StatusBadge";

// Assets
import {darkBlue100, greyishBlue50, greyishBlue700} from "assets/jss/main";

VariationImages.propTypes = {
    wmsItem: PropTypes.object.isRequired,
};

function VariationImages({wmsItem}) {
    if (!wmsItem || !wmsItem.lineItem) {
        return null;
    }

    const [selectedPictureIndex, setSelectedPictureIndex] = React.useState(0);
    const pictures = wmsItem.lineItem.pictures;

    const touchStartRef = React.useRef(null);

    const handleTouchStart = (event) => {
        touchStartRef.current = event.touches[0].clientX;
    };

    const handleTouchEnd = (event) => {
        if (touchStartRef.current === null) {
            return;
        }

        const touchEnd = event.changedTouches[0].clientX;
        const diff = touchStartRef.current - touchEnd;

        const minSwipeDistance = 50;

        if (Math.abs(diff) < minSwipeDistance) {
            return;
        }

        if (diff > 0) {
            // swiped left
            setSelectedPictureIndex(prevIndex =>
                Math.min(prevIndex + 1, pictures.length - 1)
            );
        } else {
            // swiped right
            setSelectedPictureIndex(prevIndex =>
                Math.max(prevIndex - 1, 0)
            );
        }

        touchStartRef.current = null;
    };

    // Prevent default behavior for touch move to avoid page scrolling during swipe
    const handleTouchMove = (event) => {
        if (touchStartRef.current !== null) {
            event.preventDefault();
        }
    };

    return (
        <div
            style={{
                position: 'relative',
                height: 375,
            }}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
            onTouchMove={handleTouchMove}
        >
            <div
                style={{
                    position: 'absolute',
                    top: '16px',
                    left: '16px'
                }}
            >
                <StatusBadge status={wmsItem.status} />
            </div>
            <div
                style={{
                    display: 'flex',
                    position: 'absolute',
                    bottom: 8,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    background: '#FFF',
                    border: `1px solid ${greyishBlue50}`,
                    padding: 8,
                    borderRadius: 48,
                    boxShadow: '0px 4px 32px 0px rgba(34, 34, 34, 0.06)',
                    gap: 12,
                }}
            >
                {pictures.map((picture, index) => (
                    <button
                        key={index}
                        onClick={() => setSelectedPictureIndex(index)}
                        style={{
                            width: selectedPictureIndex === index ? 24 : 8,
                            height: 8,
                            border: 'none',
                            background: selectedPictureIndex === index ? greyishBlue700 : darkBlue100,
                            borderRadius: selectedPictureIndex === index ? 48 : '50%',
                            transition: 'background 0.3s ease, borderRadius 0.3s ease, width 0.3s ease'

                        }}
                    ></button>
                ))}
            </div>
            {pictures.length > 0 && (
                <img
                    src={pictures[selectedPictureIndex]}
                    style={{
                        width: '100%',
                        objectFit: 'contain',
                        maxHeight: 355,
                    }}
                    alt="Product variation"
                />
            )}
        </div>
    );
}

export default VariationImages;
